import { Button, Card, Group, Stack, Text } from "@mantine/core";
import { IconPlus } from "@tabler/icons-react";
import type { ReactNode } from "react";
import { useAsyncAction } from "../../lib/useAsyncAction";
import { ErrorState } from "../ui";

interface AddVariantFormProps {
  title: string;
  /** The variant fields; the parent owns their state. */
  children: ReactNode;
  onGenerate: () => Promise<void>;
}

/** The compact "generate another variant for this item" panel on a detail page. */
export default function AddVariantForm({ title, children, onGenerate }: AddVariantFormProps) {
  const generate = useAsyncAction(onGenerate);
  return (
    <Card padding="sm" withBorder>
      <Stack gap="sm">
        <Text size="sm" fw={600}>
          {title}
        </Text>
        <Group align="flex-end" gap="sm" wrap="wrap">
          {children}
          <Button leftSection={<IconPlus size={16} />} loading={generate.busy} onClick={() => void generate.run()}>
            Generate
          </Button>
        </Group>
        {generate.error && <ErrorState message={generate.error} title="Generation failed" />}
      </Stack>
    </Card>
  );
}
